import {parseAsInteger} from 'nuqs';
import {createSearchParamsCache} from 'nuqs/server';
export const tableQueryParams = {
    page: parseAsInteger.withDefault(1),
    count: parseAsInteger.withDefault(20),

}

export const tableQueryParamsCache = createSearchParamsCache(tableQueryParams);
